import { render, staticRenderFns } from "./NewAppointment.vue?vue&type=template&id=6c6e4ed5&"
import script from "./NewAppointment.vue?vue&type=script&lang=js&"
export * from "./NewAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports